export default {
  home_recent_site_event: "Recent site's events",
  home_recent_device_event: "Recent device's events",
  home_pie_total: 'Total',
  home_pie_legend_enable: 'Enabled',
  home_pie_legend_disable: 'Disabled',
  home_pie_alarm: 'Alarms',
  home_pie_device: 'Devices',
  home_pie_model: 'Models',
  home_pie_fault: 'Fault',
  home_pie_no_fault: 'No Fault',
  home_pie_part_fault: 'Part Fault',
  home_pie_idle: 'Idle',
  home_pie_restarting: 'Restarting',
  home_pie_updating: 'Updating',
  home_pie_working: 'Working',

  // 站点
  home_pie_site_enabled: 'Enabled Sites',
  home_pie_site_disabled: 'Disabled Sites',

  home_pie_device_alarm: 'Device Alarm',
  home_pie_device_count: 'Device Count',
  home_pie_device_model: 'Device Model',

  // 故障
  home_fault_statistics: 'Fault Statistics',
  home_fault_ranking: 'Fault Ranking',

  // 单位
  home_device_units: 'devices',
  home_site_units: 'sites',
};
